import { BodyTextLarge, SubheaderText } from '@/utils/global-fonts';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BsFillInfoCircleFill, BsXCircle } from 'react-icons/bs';

const CarouselContainer = styled.div`
  margin-top: 16px;
  min-height: 40vh;
  display: ${(props) => (props.isInModal ? 'contents' : 'initial')};
  width: ${(props) => (props.isInModal ? '800px' : 'initial')};

  position: ${(props) => (props.isInModal ? 'fixed' : 'sticky')};
  top: 0;
  z-index: 10; /* Adjust z-index if needed */

  img {
    border-radius: 8px;

    width: ${(props) => (props.isInModal ? '100%' : 'auto')};
    /* min-height: ${(props) => (props.isInModal ? '360px' : 'initial')}; */
    height: auto; /* Maintains aspect ratio */
    object-fit: contain;
    object-position: center center;
  }

  .image-gallery {
    width: 100%;
    height: auto; /* Adjusts height based on content */
    /* min-height: ${(props) => (props.isInModal ? '360px' : 'initial')}; */
  }

  img.image-gallery-image {
    border-radius: 0px;
  }

  .image-gallery-content .image-gallery-slide .image-gallery-image {
    /* min-height: ${(props) => (props.isInModal ? '360px' : 'initial')}; */
    object-fit: contain;
  }

  iframe {
    border: ${(props) => (props.isInModal ? 'none' : 'initial')};
  }

  .image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
    margin-left: 15px;
    margin-right: 15px;
  }

  .image-gallery-thumbnail {
    width: ${(props) => (props.isInModal ? '120px' : 'initial')};
    vertical-align: middle;
    object-fit: contain;
    object-position: center center;
  }

  .image-gallery-thumbnail .image-gallery-thumbnail-image {
    vertical-align: middle;
    line-height: 0;
    object-fit: contain;
    object-position: center center;
    border-radius: 6px;
    min-height: unset !important;
  }

  .image-gallery-thumbnail .image-gallery-thumbnail-inner {
    display: flex;
    position: relative;
    height: 100%;
    width: 100%;
  }

  .image-gallery-thumbnail {
    div {
      iframe {
        height: 88px;
        border-radius: 12px;
      }
    }
  }
`;

const WrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: hidden;
  padding: 0;
`;

const WrapperChild = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 188px);
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: auto;
  height: calc(100vh - 188px);
`;

const SubContainer = styled.div`
  display: flex;
  min-height: 100%;
  height: fit-content;
  width: 100%;
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  flex: 0.7;
`;

const MainOptionsContainer = styled.div`
  background: ${(props) => props.theme.COLOR_WHITE};
  flex: 0.3;
  min-width: 500px;
  padding: 24px;
  min-height: calc(100vh - 250px);
  overflow-y: auto;
`;

const Footer = styled.div`
  width: 100%;
  min-height: 64px;
  background-color: ${(props) => props.theme.COLOR_BLACK};
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 64px;
`;

const Option = styled.div`
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: ${(props) => `1px solid ${props.theme.COLOR_GREY5}`};
  cursor: pointer;
  padding-left: ${(props) => `${props.level}px`};
  min-width: ${(props) => props.minWidth};
  width: 100%;
  overflow: hidden;
  ${(props) =>
    props.isFirst &&
    `
    border-top: none;
  `}
`;

const OptionFolder = styled(Option)`
  height: auto;
  border: ${(props) =>
    `1px solid ${props.isSelected ? props.theme.COLOR_BLACK : props.theme.COLOR_GREY5}`};
  border-radius: 4px;
  padding-left: 0;
  margin-bottom: 8px;
  margin-top: 8px;

  @media (hover: hover) {
    &:hover {
      border: ${(props) => `1px solid ${props.theme.COLOR_BLACK}`};
    }
  }
`;

const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  flex-basis: ${(props) => (props?.fullWidth ? '100%' : '50%')};
  flex-grow: 0;
  flex-shrink: 0;
  padding: ${(props) => (props?.$padding ? props.$padding : '8px')};
  margin-top: ${(props) => (props?.$marginTop ? props.$marginTop : '0')};
`;

const OptionCardContainer = styled.div`
  border: ${(props) =>
    props.selected
      ? `1px solid ${props.theme.COLOR_BLACK}`
      : `1px solid${props.theme.COLOR_GREY5}`};
  border-radius: 4px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  svg {
    margin: 0 0 0 4px;
    cursor: pointer;
  }

  p {
    font-weight: ${(props) => (props.selected ? 600 : 400)};
    padding: 0 16px;
    font-size: 14px;
    text-align: left;
    svg {
      fill: ${(props) => props.theme.COLOR_TEXT};
    }
  }

  @media (hover: hover) {
    &:hover {
      border: 1px solid ${(props) => props.theme.COLOR_BLACK};
    }
  }
`;

const OptionSpan = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 6px;

  p {
    padding: 0 4px;
    width: 80%;
  }
`;

const OptionCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: auto;
  border-radius: 8px;
  position: relative;

  p {
    min-height: 112px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const OptionName = styled(SubheaderText)``;

const OptionNameContainer = styled.div`
  width: 100%;
  padding: 12px;
  position: relative;
  border-top: 1px solid ${(props) => props.theme.COLOR_GREY5};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  p {
    padding: 0;
    margin: 0;
    margin-bottom: 10px;
  }
`;

const OptionFolderNameContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 12px;
  position: relative;
`;

const Required = styled.span`
  color: red;
  margin-left: 4px;
`;

const ConfigurationContainer = styled.div``;

const OverTheLineIconContainer = styled.span`
  padding: 2px;
  border-radius: 50%;
  background: ${(props) =>
    props.isBelowTheLine ? props.theme.COLOR_BLACK : props.theme.COLOR_GREY5};
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  svg {
    fill: ${(props) =>
      props.isBelowTheLine ? props.theme.COLOR_WHITE : props.theme.COLOR_GREY3};
    position: absolute;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }

  @media (hover: hover) {
    &:hover {
      background: ${(props) => props.theme.COLOR_BLACK};

      svg {
        fill: ${(props) =>
          props.isBelowTheLine
            ? props.theme.COLOR_WHITE
            : props.theme.COLOR_GREY5};
      }
    }
  }
`;

const RadioDisplay = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  border: 2px solid ${(props) => props.theme.COLOR_BLACK};
  border-radius: 50%;
  flex-shrink: 0;
  &::after {
    position: absolute;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    content: '';
    background-color: ${(props) =>
      props.$selected ? props.theme.COLOR_BLACK : 'transparent'};
  }
`;

const SmallRadioDisplay = styled.div`
  position: relative;
  width: 16px;
  height: 16px;
  border: 2px solid ${(props) => props.theme.COLOR_BLACK};
  border-radius: 50%;
  &::after {
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    content: '';
    background-color: ${(props) =>
      props.$selected ? props.theme.COLOR_BLACK : 'transparent'};
  }
`;

const FooterComponent = styled.div`
  width: 100%;
  height: 80px;
  background-color: ${(props) => props.theme.COLOR_BG_LIGHT};
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 12px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
`;

const Img = styled.img`
  width: 100%;
  min-width: 120px;
  height: auto;
  object-fit: cover;
`;

const OptImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  margin: 0 0 0 0px;
`;

const ThumbnailContainer = styled.div`
  height: 40px;
  width: 64px;
  margin: 0 12px 0 0;
`;

const ThumbnailOptionFolderContainer = styled.div`
  height: 100%;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 12px;
  flex-shrink: 0;
  border-right: 1px solid ${(props) => props.theme.COLOR_GREY5};
`;

const SelectedOptionContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 12px 0;
`;

const FolderContainer = styled.div`
  padding-left: ${(props) => `${props.level}px`};
  width: 100%;
`;

const DropdownContainer = styled.div`
  padding-left: ${(props) => `${props.level}px`};
  width: 100%;
  margin-bottom: 8px;
`;

const StyledBodyTextLarge = styled(BodyTextLarge)`
  margin: 12px 0;
`;

const StyledChildrenContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: ${(props) => (props.shouldWrap ? 'wrap' : 'nowrap')};
  align-content: flex-start;
  height: ${(props) => (props.isExpanded ? 'auto' : '0')};
  margin-bottom: ${(props) => (props.isExpanded ? '5px' : '0')};
  overflow: hidden;
`;

const StyledButton = styled.button`
  width: 88px;
  height: 32px;
  border: 1px solid ${(props) => props.theme.COLOR_WHITE};
  border-radius: 3px;
  background-color: ${(props) =>
    props.back ? props.theme.COLOR_BLACK : props.theme.COLOR_WHITE};
  outline: none;
  color: ${(props) =>
    props.back ? props.theme.COLOR_WHITE : props.theme.COLOR_BLACK};
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;

  &:disabled {
    cursor: no-drop;
    background-color: ${(props) => props.theme.COLOR_DISABLED_BUTTON};
  }
`;

const ModalBody = styled.div`
  min-height: 30vh;
  max-height: 80vh;
  overflow-y: auto;
  padding: ${(props) => (props.noPadding ? '0px' : '0 24px 24px 24px')};
`;

const ImageContainer = styled.div`
  height: 128px;
  width: 192px;
  display: flex;
  align-items: center;
  display: inline-block;
`;

const ImageWrapper = styled.div`
  width: 100%;
  margin: 24px 0;
`;

const ThumbnailImage = styled.img`
  width: ${(props) => (props.full ? '100%' : '64px')};
  border-radius: 4px;
  margin: 0 auto;
`;

const ForcedOptionContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 12px 0;
`;

const CustomSubheaderText = styled(SubheaderText)`
  margin: 16px 0;
`;

const OptionalDependencyComponent = styled.div`
  display: flex;
  flex-direction: column;

  span {
    margin: 0 36px;
  }
`;

const Drawer = styled(motion.div)`
  overflow: hidden;
  width: 100%;
`;

const InfoIcon = styled(BsFillInfoCircleFill)`
  position: ${(props) => (props.relative ? 'block' : 'absolute')};
  bottom: 5%;
  right: 5%;
  fill: ${(props) => props.theme.COLOR_TEXT};
  @media (hover: hover) {
    &:hover {
      fill: ${(props) => props.theme.COLOR_BLACK};
    }
  }
`;

const SelectedOptionHolder = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const DeselectIcon = styled(BsXCircle)`
  position: ${(props) => (props.relative ? 'block' : 'absolute')};
  bottom: 5%;
  right: 5%;
  fill: ${(props) => props.theme.COLOR_TEXT};
  @media (hover: hover) {
    &:hover {
      fill: ${(props) => props.theme.COLOR_BLACK};
    }
  }
`;

const SelectedOptionLabel = styled.div`
  font-weight: 500;
  font-size: 16px;
  margin-left: 12px;
  color: ${(props) => props.theme.COLOR_BLACK};
`;

const InfoIconOptionFolder = styled(BsFillInfoCircleFill)`
  fill: ${(props) => props.theme.COLOR_TEXT};
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
`;

const A = styled.a`
  color: ${(props) => props.theme.COLOR_LINK};
`;

const Iframe = styled.iframe`
  z-index: 2;
  height: 100%;
  width: 100%;
  border: none;
  border-radius: 8px;
`;

const HeadingMainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeadingContainer = styled.div``;

const TitleContainer = styled.div`
  margin: 16px 0px 0px 0px;
`;

const DescriptionContainer = styled.div`
  margin: 0px 20px;
`;

const IconHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ActionHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const ActionHolderOptionFolder = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin-right: 5px;
`;

const Styled = {
  ActionHolderOptionFolder,
  ActionHolder,
  Container,
  FolderContainer,
  FooterComponent,
  HeaderContainer,
  Img,
  OptImg,
  Option,
  OptionFolder,
  OptionCard,
  OptionCardContainer,
  OptionName,
  OptionSpan,
  OverTheLineIconContainer,
  RadioDisplay,
  Required,
  ImageWrapper,
  SelectedOptionContainer,
  SmallRadioDisplay,
  StyledBodyTextLarge,
  StyledChildrenContainer,
  ThumbnailContainer,
  CarouselContainer,
  ConfigurationContainer,
  Footer,
  LeftContainer,
  MainContainer,
  MainOptionsContainer,
  StyledButton,
  WrapperChild,
  WrapperContainer,
  ModalBody,
  ImageContainer,
  ThumbnailImage,
  SubContainer,
  ForcedOptionContainer,
  CustomSubheaderText,
  OptionalDependencyComponent,
  Drawer,
  InfoIcon,
  OptionNameContainer,
  OptionFolderNameContainer,
  ButtonContainer,
  A,
  Iframe,
  HeadingMainContainer,
  HeadingContainer,
  DescriptionContainer,
  TitleContainer,
  ThumbnailOptionFolderContainer,
  InfoIconOptionFolder,
  IconHolder,
  OptionContainer,
  DeselectIcon,
  SelectedOptionLabel,
  SelectedOptionHolder,
  DropdownContainer,
};

export default Styled;
